<style>
.painelButton {
  position: fixed;
  z-index: 9;
  top: 5px;
  margin-left: -20px;
  color: white;
  border: none;
}
@media screen and (min-width: 991px) {
  .menuView {
    margin-left: 415px;
    margin-top: 60px;
    overflow-x: hidden;
  }
}
</style>

<template>
  <div class="profissional">
    <b-row no-gutters>
      <b-col cols="12">
        <b-navbar toggleable fixed>
          <b-navbar-toggle target="">
            <b-button class="painelButton" v-b-toggle.painelAdm variant="outilene">
              <i class="fas fa-bars c-orange fs-30"></i> 
            </b-button>
          </b-navbar-toggle>
          <b-sidebar 
            v-model="painelAdm" 
            id="painelAdm" 
            shadow 
            width="400px"
            :no-close-on-route-change="windowWidth > 991 ? true : false"
          >
            <b-navbar-brand>
              <div class="brandAlign">
                <img
                  src="@/assets/img/Logo Novo ConstrUp.png"
                  alt="Logo Constr Up"
                  width="180"
                />
              </div>
            </b-navbar-brand>
            <b-navbar-nav>
              <div class="p-2 bg-gray-1 pl-3 pb-5">
                <!-- <Topic :text="'Informações'" :icon="'fas fa-user-circle'" />
                <BasicItem
                  :text="'Meus Dados'"
                  :icon="'fas fa-list-alt'"
                  :routeName="'profissional-meus-dados'"
                />
                <BasicItem
                  :text="'Sair'"
                  :icon="'fas fa-power-off'"
                  :routeName="'sair'"
                />

                <Topic
                  class="mt-4"
                  :text="'Orçamentos'"
                  :icon="'fas fa-clipboard-list'"
                />
                <Item
                  :icon="'fas fa-arrow-circle-up'"
                  :count="cotacoesContagem.solicitados"
                  :pushToRouteName="'profissional-solicitados'"
                  :itemText="'Solicitados'"
                  :iconStyle="'transform: rotate(45deg)'"
                />
                <Item
                  :icon="'fas fa-arrow-circle-down'"
                  :count="cotacoesContagem.respondidas"
                  :pushToRouteName="'profissional-respondidas'"
                  :itemText="'Respondidos'"
                  :iconStyle="'transform: rotate(45deg)'"
                />

                <Topic
                  class="mt-4"
                  :text="'Pedidos'"
                  :icon="'fas fa-clipboard-check'"
                />
                <Item
                  :icon="'fas fa-money-bill'"
                  :count="cotacoesContagem.pendente"
                  :pushToRouteName="'profissional-aguardando-pagamento'"
                  :itemText="'Processando pagamento'"
                />
                <Item
                  :icon="'fas fa-stopwatch'"
                  :count="cotacoesContagem.aguardando"
                  :pushToRouteName="'profissional-aguardando'"
                  :itemText="'Conferindo Materiais'"
                />
                <Item
                  :icon="'fas fa-thumbs-up'"
                  :count="cotacoesContagem.aprovadas"
                  :pushToRouteName="'profissional-aprovadas'"
                  :itemText="'Pedidos Aprovados'"
                />
                <Item
                  :icon="'fas fa-check-circle'"
                  :count="cotacoesContagem.finalizadas"
                  :pushToRouteName="'profissional-finalizadas'"
                  :itemText="'Pedidos Entregues'"
                />

                <Topic
                  class="mt-4"
                  :text="'Orçamentos Rejeitados'"
                  :icon="'fas fa-times-circle'"
                />
                <Item
                  :icon="'fas fa-thumbs-down'"
                  :count="cotacoesContagem.rejeitadasPU"
                  :pushToRouteName="'profissional-rejeitadas-pelo-usuario'"
                  :itemText="'Por Você'"
                />
                <Item
                  :icon="'fas fa-times'"
                  :count="cotacoesContagem.rejeitadasPL"
                  :pushToRouteName="'profissional-rejeitadas-pelos-lojistas'"
                  :itemText="'Pelos Lojistas'"
                /> -->

                <BasicItem
                  :text="'Meus Dados'"
                  :icon="'fas fa-list-alt'"
                  :routeName="'profissional-meus-dados'"
                />
                <BasicItem
                  :text="'Meu Perfil'"
                  :icon="'fas fa-user'"
                  :routeName="'profissional-meu-perfil'"
                />
                <BasicItem
                  :text="'Minha assinatura'"
                  :icon="'fas fa-hand-holding-usd'"
                  :routeName="'profissional-minha-assinatura'"
                />
                <!-- <BasicItem
                  :text="'Assinatura Site'"
                  :icon="'fas fa-pager'"
                  :routeName="'profissional-assinatura-site'"
                  v-if="websiteSolicitationStatus == '' || websiteSolicitationStatus < 3"
                /> -->
                <Topic
                  isSectionApp
                  text="Meu site"
                  icon="fa fa-desktop"
                  class="my-4 cursor-pointer"
                  v-if="websiteSolicitationStatus > 2"
                  @click="openWebsiteSection = !openWebsiteSection"
                />
                <div v-if="openWebsiteSection && websiteSolicitationStatus > 2">
                  <Topic class="mt-4" text="Customizações" icon="fas fa-cog" />
                  <Item
                    icon="fas fa-palette"
                    pushToRouteName="profissional-website-customizacao"
                    itemText="Mudar cor e sobre"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-image"
                    pushToRouteName="profissional-website-banner"
                    itemText="Banners"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-hashtag"
                    pushToRouteName="profissional-website-redes-sociais"
                    itemText="Contato e redes sociais"
                    hideCountBadge
                  />
                </div>
              </div>
            </b-navbar-nav>
          </b-sidebar>  
        </b-navbar>
      </b-col>
      <b-col :class="painelAdm ? 'menuView' : 'mx-1 mt-5'">
        <div class="mx-1">
          <router-view />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';

export default {
  name: 'profissional',
  components: {
    Item,
    Topic,
    BasicItem,
  },
  data: () => ({
    isSlowCotacao: true,
    isSlowDados: true,
    isSlowConfigurate: true,
    isSlowMeuPerfil: true,
    openWebsiteSection: true,
    websiteSolicitationStatus: null,
    painelAdm: false,
    windowWidth: null,
    websiteSolicitationStatus: null,
  }),
  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoesContagem: (state) => state.cotacoesContagem,
    }),
  },
  watch: {
    $route() {
      this.contagemCotacoes();
    },
  },
  
  mounted () {
    window.addEventListener("resize", this.handleResize);
    this.widthWindow();

    this.$root.$on('valid-status-site', () => {
      this.getWebsiteSolicitation(); 
    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  created() {
    if (this.dadosUsuario) {
      this.contagemCotacoes();
    }

    this.getWebsiteSolicitation();
  },
  methods: {
    ...mapActions('professional', ['getWebsiteSolicitationStatus']),
    contagemCotacoes() {
      this.$store.dispatch('showContagemCotacoes', this.dadosUsuario);
    },
    getWebsiteSolicitation() {
      this.getWebsiteSolicitationStatus(this.dadosUsuario.informacoes.id)
        .then((response) => {
          this.websiteSolicitationStatus = (response.data.data || {}).status || '';
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 991) this.painelAdm = true;
    },
    widthWindow() {
      if (this.windowWidth > 991) this.painelAdm = true;
    },
  },
};
</script>
